class TabUiController {
  makeItem(name, props = {}) {
    return {
      name: Number(String(name)).toLocaleString('pt-BR', { minimumFractionDigits: 0 }),
      ...props,
    };
  }
}

export const tabUiController = new TabUiController();
